import {GetCityLocationParams} from 'domain/usecases/private/booking-flow/health/get-city-location';
import {makeGetCityLocation} from 'main/factories/usecases/private/booking-flow/remote-health-booking/get-city-location-factory';

async function getCityLocation({latitude, longitude, signal}: GetCityLocationParams) {
	if (!latitude || !longitude) throw new Error('Invalid location');

	const cityLocationParams = {
		latitude,
		longitude,
		signal,
	};

	return makeGetCityLocation().get(cityLocationParams);
}

export {getCityLocation};
